import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Radio, Select, Tooltip, Checkbox } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";
import puzzle from "../../../../assets/img/bl.svg";
import { ReceptionRadioButtons } from "../buttons/reception-button.js";
import Title from "./components/title.js";
import CustomSwitchButtons from "../CustomSwitchButtons";
import { TackleRadioButtons, FlagSwitchButtons } from "../CustomSwitchButtons";
import { useNavigate } from "react-router-dom";
import positiveImpact from "../../../../assets/img/positiveImpact.svg";
import positiveImpactAction from "../../../../assets/img/Action.svg";

function KickerModal({
  state,
  dispatch,
  close,
  update,
  item,
  school_id,
  loadAllPlayerList,
  play,
  handleUpdatePlay,
  updateInputGrade,
  updateGrade,
  handleExpandToggle,
  handleQuickUpdate,
  schoolCustomStats,
}) {
  const [modalWidth, setModalWidth] = useState(680);
  const [showMoreOnside, setShowMoreOnside] = useState(false);
  const [showMoreKickoff, setShowMoreKickoff] = useState(false);

  let history = useNavigate();
  const [customStats, setCustomStats] = useState([]);
  const [customStatValues, setCustomStatValues] = useState({});
  const [storage, setStorage] = useState({});

  const handleSaveCustomStat = (stat, value) => {
    const _customStatValues = { ...customStatValues };
    _customStatValues[stat.label] = value;
    setCustomStatValues(_customStatValues);

    updateGrade("custom_stats", JSON.stringify(_customStatValues));
  };
  useEffect(() => {
    setStorage(item);
  }, [item]);
  const updateStorage = (path, value) => {
    const store = storage;
    store[path] = value;
    setStorage(store);
    updateGrade(path, value);
  };

  const handleCStats = () => {
    setCustomStatValues(JSON.parse(item.custom_stats || "{}"));
    const _customStats = schoolCustomStats?.filter((stat) => stat.odk == "k");
    setCustomStats(_customStats || []);
  };

  useEffect(() => {
    if (showMoreKickoff || showMoreOnside) {
      setModalWidth(800);
    }
  }, [showMoreKickoff, showMoreOnside]);

  useEffect(() => {
    if (window.innerWidth >= 768) {
      setModalWidth(680);
    } else {
      setModalWidth(800);
    }
  }, [window.innerWidth]);

  return (
    state.return && (
      <div
        style={{ border: "1px solid #F3F5F7" }}
        className="text-xs text-[#0F1A24] flex items-start justify-between w-full"
      >
        <div className="w-[65%]">
          <div className="flex " style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] bg-[#F3F5F7] px-2 py-2 font-bold flex items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Flag</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <FlagSwitchButtons
                item={item}
                defaultState={item?.penalties}
                handleQuickUpdate={handleQuickUpdate}
                title="penalties"
              />
            </div>
          </div>
          <div className="flex w-full">
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7]"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Tackle</span>
            </div>
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center"
            >
              <TackleRadioButtons
                item={item}
                defaultState={item.tackles}
                handleQuickUpdate={handleQuickUpdate}
                title="tackles"
                tooltipTitle="Missed Tackle"
                textTwo="AST"
                tooltipTitleTwo="Assisted Tackle"
                textThree={1}
              />
            </div>
          </div>
          <div className="flex w-full">
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex items-center"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Unselfish Block</span>
            </div>{" "}
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center"
            >
              <CustomSwitchButtons
                item={item}
                defaultState={item?.catchable_balls}
                handleQuickUpdate={handleQuickUpdate}
                title="catchable_balls"
              />{" "}
            </div>
          </div>

          <div className="flex">
            <div
              className="w-[25%] font-bold bg-[#F3F5F7] flex items-center px-2 py-2"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Kickoff Return</span>
            </div>{" "}
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center"
            >
              <Switch
                defaultChecked={item.kickoff_return}
                onChange={(e) => {
                  setShowMoreKickoff(e);
                  updateGrade("kickoff_return", e ? 1 : 0);
                }}
              />{" "}
            </div>
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[20%] turn-over actor flex items-center justify-center"
            >
              <Input
                onChange={({ target: { value } }) =>
                  handleUpdatePlay(play.id, { gn: value })
                }
                defaultValue={play.gn}
                size="large"
                placeholder="Gn/ls"
              />
            </div>
            {showMoreKickoff || item.kickoff_return ? (
              <>
                <div className="px-2 py-2 w-[28%] turn-over actor flex items-center justify-center">
                  <Checkbox
                    defaultChecked={item.kickoff_fair_catch}
                    onChange={({ target: { checked: e } }) => {
                      updateGrade("kickoff_fair_catch", e ? 1 : 0);
                    }}
                  >
                    <span className="text-[#2E4D6B]">Fair Catch</span>
                  </Checkbox>
                </div>
              </>
            ) : null}
          </div>

          <div className="flex w-full">
            <div
              className="w-[25%] px-2 py-2 flex items-center font-bold bg-[#F3F5F7]"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Punt Return</span>
            </div>{" "}
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center"
            >
              <Switch
                defaultChecked={item.punt_return}
                onChange={(e) => {
                  setShowMoreOnside(e);
                  updateGrade("punt_return", e ? 1 : 0);
                }}
              />{" "}
            </div>
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[20%] turn-over actor flex items-center justify-center"
            >
              <Input
                onChange={({ target: { value } }) =>
                  handleUpdatePlay(play.id, { gn: value })
                }
                defaultValue={play.gn}
                size="large"
                placeholder="Gn/ls"
              />
            </div>
            {showMoreOnside || item.punt_return ? (
              <>
                <div className="px-2 py-2 w-[28%] turn-over actor flex items-center justify-center">
                  <Radio.Group
                    name="radiogroup"
                    onChange={({ target: { value } }) =>
                      updateGrade("punt_return_fair_catch", value)
                    }
                    defaultValue={item.punt_return_fair_catch}
                    className="flex items-center"
                  >
                    <Radio value={1}>
                      {" "}
                      <span className="text-[#2E4D6B]">Fair Catch </span>
                    </Radio>
                    <Radio value={0}>
                      {" "}
                      <span className="text-[#2E4D6B]">No Catch</span>
                    </Radio>
                  </Radio.Group>
                </div>
              </>
            ) : null}
          </div>

          <div
            className="flex w-full"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7]  flex items-center"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Fumble</span>
            </div>{" "}
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[25%] fumble flex items-center justify-center"
            >
              {item?.fumble == 1 ? (
                <Switch
                  checked={true}
                  onChange={(e) => updateGrade("fumble", e ? 1 : 0)}
                />
              ) : (
                <Switch
                  checked={false}
                  onChange={(e) => updateGrade("fumble", e ? 1 : 0)}
                />
              )}
            </div>
            {item?.fumble == 1 && (
              <div
                style={{ border: "1px solid #f3f5f7" }}
                className="px-1 py-2 w-[20%] turn-over actor flex items-center justify-center"
              >
                <Checkbox
                  defaultChecked={item?.fumble_lost}
                  onChange={({ target: { checked: e } }) =>
                    updateGrade("fumble_lost", e ? 1 : 0)
                  }
                >
                  <span className="text-[#2E4D6B] text-sm ">Fumble Lost</span>
                </Checkbox>
              </div>
            )}
          </div>

          <div
            className="flex w-full"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7]"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Onside Recovered</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={item.onsidekick_recovered}
                onChange={(e) => updateGrade("onsidekick_recovered", e ? 1 : 0)}
              />{" "}
            </div>
          </div>

          <div
            className="flex w-full"
            style={{ borderBottom: "1px solid #F3F5F7" }}
          >
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7]"
              style={{ border: "1px solid #F3F5F7" }}
            >
              <span>Return TD</span>
            </div>{" "}
            <div
              style={{ border: "1px solid #f3f5f7" }}
              className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center"
            >
              <Switch
                defaultChecked={Number(item.return_td)}
                onChange={(e) => updateGrade("return_td", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div className="flex " style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Caused Fumble</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={Number(item.caused_fumble)}
                onChange={(e) => updateGrade("caused_fumble", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div className="flex" style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Punt Block</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={Number(item.punt_blocks)}
                onChange={(e) => updateGrade("punt_blocks", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div className="flex" style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] items-center flex "
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>FG Block</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={Number(item.fg_blocks)}
                onChange={(e) => updateGrade("fg_blocks", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div className="flex" style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Fumble/Block Recovery</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={Number(item.recovered_fumble)}
                onChange={(e) => updateStorage("recovered_fumble", e ? 1 : 0)}
              />{" "}
            </div>
          </div>

          {storage.recovered_fumble == 1 ? (
            <div
              className="flex "
              style={{ borderBottom: "1px solid #F3F5F7" }}
            >
              <div
                className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex items-center"
                style={{ borderRight: "1px solid #F3F5F7" }}
              >
                <span>Yards After Recovery</span>
              </div>{" "}
              <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
                <Input
                  defaultValue={item.yards_after_recovery}
                  onChange={(e) => updateInputGrade("yards_after_recovery", e)}
                  size="small"
                  className="w-[25%] p-1"
                />{" "}
              </div>
            </div>
          ) : (
            ""
          )}

          <div className="flex " style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex  items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>TD</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <Switch
                defaultChecked={Number(item.st_td)}
                onChange={(e) => updateGrade("st_td", e ? 1 : 0)}
              />{" "}
            </div>
          </div>
          <div className="flex " style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold bg-[#F3F5F7] flex items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>2 Pt. Conversion</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              {item?.two_part_conversion == 1 ? (
                <Switch
                  checked={true}
                  onChange={(e) =>
                    updateGrade("two_part_conversion", e ? 1 : 0)
                  }
                />
              ) : (
                <Switch
                  checked={false}
                  onChange={(e) =>
                    updateGrade("two_part_conversion", e ? 1 : 0)
                  }
                />
              )}
            </div>
          </div>
          <div className="flex " style={{ borderBottom: "1px solid #F3F5F7" }}>
            <div
              className="w-[25%] px-2 py-2 font-bold  bg-[#F3F5F7] flex items-center"
              style={{ borderRight: "1px solid #F3F5F7" }}
            >
              <span>Positive Impact</span>
            </div>{" "}
            <div className="px-2 py-2 w-[25%] turn-over actor flex items-center justify-center">
              <div
                onClick={() => {
                  if (item?.disabled) return;
                  handleQuickUpdate(
                    item?.id,
                    item?.athlete,
                    "positive_impact",
                    !item?.positive_impact ? 1 : 0
                  );
                }}
                className="flex w-[100%] items-center justify-center"
              >
                {item?.positive_impact == 1 && (
                  <img
                    src={positiveImpactAction}
                    className="w-[60%] max-w-[38px] cursor-pointer"
                  />
                )}
                {(item?.positive_impact === 0 || !item?.positive_impact) && (
                  <img
                    src={positiveImpact}
                    className="w-[60%] max-w-[38px] cursor-pointer"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="w-[33%] px-2 self-start">
          <div className="flex items-center text-md mb-2">
            <button
              onClick={() => handleExpandToggle(item, "special-teams-modal")}
              className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
            >
              <img src={floppyDiskImg} className="w-6" />
              <span className="ml-2">Save and close</span>
            </button>
          </div>
          {customStats?.length > 0 && (
            <>
              <span className="font-inter text-[14px] font-bold">
                Custom Stats{" "}
              </span>
              <div
                style={{ border: "1px solid #F3F5F7" }}
                className="mt-1 text-[12px] text-[#0F1A24] mb-2"
              >
                {customStats.map((stat) => (
                  <div
                    key={stat.label}
                    className="flex"
                    style={{ borderBottom: "1px solid #F3F5F7" }}
                  >
                    <div
                      className="w-[50%] px-2 py-2 font-bold flex items-center"
                      style={{ borderRight: "1px solid #F3F5F7" }}
                    >
                      <span>{stat.label}</span>
                    </div>{" "}
                    <div className="px-2 py-2 w-[50%] turn-over actor flex items-center justify-center">
                      {stat.input_type == "numeric" ? (
                        <Input
                          defaultValue={
                            JSON.parse(item.custom_stats || "{}")[stat.label]
                          }
                          onChange={(e) =>
                            handleSaveCustomStat(stat, e.target.value)
                          }
                          size="small"
                          className="w-[25%] p-1"
                        />
                      ) : (
                        <Switch
                          defaultChecked={
                            JSON.parse(item.custom_stats || "{}")[stat.label]
                          }
                          onChange={(e) =>
                            handleSaveCustomStat(stat, e ? 1 : 0)
                          }
                        />
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
          <span className="text-[#8698A9]">
            Edit custom stats in your{" "}
            <span
              onClick={() => history("/add-stats")}
              className="underline cursor-pointer"
            >
              Admin Settings
            </span>
          </span>
        </div>
      </div>
    )
  );
}

export default KickerModal;
